import reportGenerator from "./reportGenerator.component";
import reportGeneratorUrls from "./reportGenerator.urls";
import ReportGeneratorTransforms from "./reportGenerator.transforms";

const reportGeneratorModule = angular
  .module("app.components.reportGenerator", [])
  .component("reportGeneratorPage", reportGenerator)
  .service("ReportGeneratorTransforms", ReportGeneratorTransforms)
  .config(reportGeneratorUrls);

export default reportGeneratorModule;



// WEBPACK FOOTER //
// ./src/pages/reportGenerator/reportGenerator.module.js